import { LuBriefcase, LuBuilding, LuGraduationCap, LuUsers } from 'react-icons/lu';
import heroEmployersImg from '../../../../assets/images/landing/hero-employers-illustration.svg';
import heroEmployeesImg from '../../../../assets/images/landing/hero-employees-illustration.svg';

export const getCardData = (t, Info) => [
  {
    icon: <LuBriefcase size={32} />,
    count: Info?.vacancyAmount,
    type: t('vacancy'),
  },

  {
    icon: <LuGraduationCap size={32} />,
    count: Info?.internshipAmount,
    type: t('internship'),
  },
  {
    icon: <LuBuilding size={32} />,
    count: Info?.companyAmount,
    type: t('employers'),
  },
  {
    icon: <LuUsers size={32} />,
    count: Info?.userAmount,
    type: t('jobSeekers'),
  },
];
export const HERO_IMAGES = {
  employers: {
    src: heroEmployersImg,
    alt: 'Hero Employers Illustration',
  },
  employees: {
    src: heroEmployeesImg,
    alt: 'Hero Employees Illustration',
  },
};
